const ErrorCode = {
  MISSING_KEY: 'MISSING_KEY',
  EMPTY_KEY: 'EMPTY_KEY',
  INVALID_SPACE_CHARACTER: 'INVALID_SPACE_CHARACTER',
  INVALID_SPECIAL_CHARACTERS: 'INVALID_SPECIAL_CHARACTERS',
};

const validateKey = (key) => {
  if (!key) {
    const error = new Error('Missing key');
    error.code = ErrorCode.MISSING_KEY;
    return error;
  }

  if (!key.trim()) {
    const error = new Error('Empty key');
    error.code = ErrorCode.EMPTY_KEY;
    return error;
  }

  if (key.indexOf(' ') > -1) {
    const error = new Error('Must not contain spaces');
    error.code = ErrorCode.INVALID_SPACE_CHARACTER;
    return error;
  }

  if(!key.match(/^[-A-Za-z0-9()]+$/g)) {
    const error = new Error('Invalid special characters');
    error.code = ErrorCode.INVALID_SPECIAL_CHARACTERS;
    return error;
  }
};

module.exports = { ErrorCode, validateKey };



// WEBPACK FOOTER //
// ./common/validation/key.js